export default function useExternalLinkProps(url: string | null | undefined) {
  const linkProps = (() => {
    if (!url) return {}

    if (import.meta.env.PUBLIC_PLATFORM === 'telegram') {
      return {
        as: 'button' as const,
        onClick: () => Telegram.WebApp.openLink(url),
      }
    }

    return {
      as: 'a' as const,
      href: url,
    }
  })()

  return linkProps
}
